import { render } from "./EditAdminProfile.vue?vue&type=template&id=2a30af3f"
import script from "./EditAdminProfile.vue?vue&type=script&lang=js"
export * from "./EditAdminProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__